import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {

  constructor(private http: HttpClient) {}

  getPropertiesData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/properties`);
  }

  updatePropertiesData(formsId: number, propertiesId: number, data: any): Observable<any> {
    return this.http.patch(`${environment.api_guia}forms/${formsId}/properties/${propertiesId}`, data);
  }
}
